import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listOfBookmarkedProducts } from '../../redux/product/productActions'
import ProductBox from "../../components/Entities/Product/ProductBoxBookmark"
import AlertMessage from "../../components/Global/Message/Alert";
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Loader from "../Global/Loader/Index";

const useStyles = makeStyles((theme) => ({
    title: {
        backgroundColor: '#950000',
        borderRadius: '10px',
        color: '#fff',
        fontWeight: '700'
    },
    paperNoBg: {
        backgroundColor: 'transparent',
    },
    container: {
        backgroundColor: '#F3F3F3',
        margin: '-10px auto',
        padding: '20px',
        borderBottomRadius: '10px',
        width: '98%',

    },
    whitecontainer: {
        margin: '0px',
    },
    green: {
        backgroundColor: "#417557",
        boxShadow: "none",
        color: "#fff",
        width: "140px",
        "&:hover": {
            background: "#447557",
        },
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginRight: '17px'
        },
    },
    btnChangePass: {
        [theme.breakpoints.down('xs')]: {
            marginTop: '15px',
            marginBottom: '15px',
        }
    },
    whiteBox: {
        background: "#fff",
        borderRadius: '20px',
    },
    whiteBox2: {
        background: "#fff",
        borderRadius: '20px',
        [theme.breakpoints.up('sm')]: {
            minHeight: '507px',
        }
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "170px",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#616161",
        border: "1px solid #D0D0D0",
        borderBottom: "none",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px 10px 0px 0px",
        maxWidth: "170px",
        backgroundColor: "#F3F3F3",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#F3F3F3",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
    },
    show: {
        display: "block",
    },
    hide: {
        display: "none",
    },
    label: {
        lineHeight: "32px",
        fontSize: "13px",
        fontWeight: "700",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: '0px',
    },
    modalContainer: {
        padding: theme.spacing(2, 4, 3),
        paddingLeft: "25px",
        paddingBottom: "50px",
        paddingRight: "25px",
    },
    paperModal: {
        width: "470px",
        background: "#F9F9F9",
        boxSizing: "border-box",
        borderRadius: " 10px",
        paddingTop: '0px',
        outline: "none",

        [theme.breakpoints.down(650)]: {
            width: "85%",
        },
        [theme.breakpoints.up(2560)]: {
            width: "999px",
        },

        [theme.breakpoints.down(340)]: {
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            paddingLeft: "10px",
            paddingRight: "10px",
        },
    },
    imgC:
    {
        borderRadius: '10px',
        filter: 'drop-shadow(-4px 4px 8px rgba(0, 0, 0, 0.19))',
    }
}));

const AdminBookmarks = () => {

    const classes = useStyles()
    const [curPage, setCurPage] = useState(1)
    const dispatch = useDispatch()
    const [userTokenLocal, setUserTokenLocal] = useState(
        localStorage.getItem("token")
    );
    const bookmaredProductsList = useSelector(state => state.bookmaredProductsList)
    const {
        bLoading,
        bookmarks,
    } = bookmaredProductsList

    useEffect(() => {

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                dispatch(listOfBookmarkedProducts(curPage))

            }
        }

    }, [dispatch])

    return (
        <Box evelotion={0} mt={1}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Box evelotion={0} textAlign="center" p={1} className={classes.title}>
                        لیست نشان شده ها
                    </Box>
                </Grid>
            </Grid>
            <Grid container className={classes.container} spacing={1}>
                <Grid item md={12} xs={12} >
                    <Box evelotion={1} mt={-1} p={2}>


                        <Grid container spacing={1}>
                            {(typeof bLoading !== "undefined" && typeof bookmarks !== "undefined") ? (
                                (!bLoading) ? (
                                    (bookmarks.length > 0) ? (
                                        bookmarks.map((product, i) => (

                                            <ProductBox
                                                lang='fa'
                                                key={i}
                                                dbid={product.bookmarkId}
                                                product={product.product}
                                            />

                                        ))
                                    ) : (
                                        <AlertMessage variant="info">
                                            .موردی جهت نمایش وجود ندارد
                                        </AlertMessage>
                                    )
                                ) : (
                                    <Grid item xs={12}>
                                        <Box mt={3} textAlign="center">
                                            <Loader text="در حال بارگزاری..." />
                                        </Box>
                                    </Grid>
                                )
                            ) : (
                                <Grid item xs={12}>
                                    <Box mt={3} textAlign="center">
                                        <Loader text="در حال بارگزاری..." />
                                    </Box>
                                </Grid>
                            )}
                        </Grid>


                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}
export default AdminBookmarks